const GetAppGradient = ({ children }) => {
  return (
    <div className="max-w-inset-0">
      <div className="bg-getApp-bgGradient">{children}</div>
    </div>
  );
};

export default GetAppGradient;
